import { Component } from "react";
import { WarningCircle, ArrowClockwise } from "@phosphor-icons/react";

// Prevents a single render/data error from blanking the whole page.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="page-error-fallback" className="mx-auto my-10 max-w-lg rounded-2xl border border-amber-200 bg-amber-50 p-8 text-center">
          <WarningCircle size={40} weight="duotone" className="mx-auto mb-3 text-amber-500" />
          <h2 className="font-heading text-lg font-bold text-slate-800">Gangguan menampilkan halaman</h2>
          <p className="mt-1 text-sm text-slate-600">
            {this.props.message || "Sebagian data tidak dapat ditampilkan. Coba muat ulang halaman."}
          </p>
          <button
            data-testid="page-error-reload"
            onClick={() => window.location.reload()}
            className="mt-4 inline-flex items-center gap-1.5 rounded-xl bg-[#7C4DE0] px-4 py-2 text-sm font-bold text-white hover:bg-[#6A38C7]"
          >
            <ArrowClockwise size={16} weight="bold" /> Muat Ulang
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
